import { render, staticRenderFns } from "./CategoriesDiscounts.vue?vue&type=template&id=3da2f15a&scoped=true&"
import script from "./CategoriesDiscounts.vue?vue&type=script&lang=js&"
export * from "./CategoriesDiscounts.vue?vue&type=script&lang=js&"
import style0 from "./CategoriesDiscounts.vue?vue&type=style&index=0&id=3da2f15a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3da2f15a",
  null
  
)

export default component.exports